export const GB_ENG = {
  label: "GB_ENG",
  value: "GB_ENG",
};

export const GB_GBN = {
  label: "GB_GBN",
  value: "GB_GBN",
};

export const GB_NIR = {
  label: "GB_NIR",
  value: "GB_NIR",
};

export const GB_SCT = {
  label: "GB_SCT",
  value: "GB_SCT",
};

export const GB_WLS = {
  label: "GB_WLS",
  value: "GB_WLS",
};
